import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  Flex,
  Image,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { white, textSecondary, primaryAlt } from "../../../utils/colors";
import useThemeColors from "../../../hooks/useThemeColors";

const TabLinkNew = ({
  route,
  name,
  icon,
  id,
  subMenuItems,
  hasSubMenu,
  isDisabled,
  isSideBarTiny,
  isAccordionOpen, // ✅ Receive from parent
  onAccordionToggle, // ✅ Receive toggle function from parent
  activeAccordion,
  setActiveAccordion,
}) => {
  const location = useLocation();
  // const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const navigate = useNavigate();

  // COLORS
  const { whiteMode, newBorderMode, backgroundLightMode, textPrimaryMode } =
    useThemeColors();

  const isActive = location.pathname.startsWith(route); // Check if the current route is active

  const shouldBeOpen = subMenuItems.some((sub) =>
    location.pathname.startsWith(sub.route)
  );

  const handleAccordionClick = () => {
    onAccordionToggle(); // ✅ Toggle active accordion
    if (hasSubMenu && subMenuItems.length > 0) {
      navigate(subMenuItems[0].route);
    } else {
      // console.log("route", route);
      navigate(route);
      setActiveAccordion(null); // ✅ Ensure closing if navigating elsewhere
    }
  };

  // console.log("location.pathname", location.pathname);
  // console.log("isActive", isActive);
  // console.log("name", name);
  // console.log("id", id);

  return (
    <>
      {!hasSubMenu && (
        <Flex
          // as={NavLink}
          // to={route}
          onClick={handleAccordionClick}
          align="center"
          justify={isSideBarTiny ? "center" : "flex-start"}
          padding={isSideBarTiny ? "0 0rem" : "0 1.5rem"}
          height="56px"
          fontWeight="400"
          color={isActive ? white : textSecondary}
          bg={isActive ? primaryAlt : whiteMode}
          fontSize="15px"
          borderTopLeftRadius="16px"
          borderBottomLeftRadius="16px"
          transition="0.2s ease-in all"
          _hover={{
            background: isActive ? primaryAlt : "#f5f5f5",
            color: isActive ? white : textPrimaryMode,
          }}
          pointerEvents={isDisabled ? "none" : "auto"}
          opacity={isDisabled ? 0.5 : 1}
          flexShrink={0}
          cursor={isDisabled ? "not-allowed" : "pointer"}
          role="group" // Add role group for _groupActive styles
        >
          {icon && (
            <Image
              mr={isSideBarTiny ? "0" : "1rem"}
              src={icon}
              h={isSideBarTiny ? "18px" : "17px"}
              filter={isActive ? "invert(1)" : "none"}
              opacity={isActive ? 1 : 0.6}
            />
          )}
          {!isSideBarTiny && name}
          {/* {name} */}
        </Flex>
      )}

      {hasSubMenu && (
        <Accordion
          allowToggle
          index={isAccordionOpen || shouldBeOpen ? [0] : []}
          w="100%"
          border="none"
        >
          <AccordionItem border="none">
            <h2>
              <AccordionButton
                onClick={activeAccordion === id ? null : handleAccordionClick}
                // onClick={handleAccordionClick}
                p="0"
                borderTopLeftRadius="1rem"
                borderBottomLeftRadius="1rem"
                _hover={{
                  color: textPrimaryMode,
                  background: backgroundLightMode,
                }}
                _focus={{ boxShadow: "none" }}
              >
                <Flex
                  // as={NavLink}
                  // to={route}
                  onClick={handleAccordionClick}
                  w="100%"
                  align="center"
                  py="1rem"
                  px="1.5rem"
                  fontSize="15px"
                  borderTopLeftRadius="1rem"
                  borderBottomLeftRadius="1rem"
                  color={isAccordionOpen ? white : textSecondary}
                  bg={isAccordionOpen ? primaryAlt : whiteMode}
                  // bg="green"
                  _hover={{
                    textDecoration: "none",
                    color: textPrimaryMode,
                    background: backgroundLightMode,
                  }}
                  pointerEvents="none"
                >
                  {icon && (
                    <Image
                      mr="1rem"
                      src={icon}
                      h={isSideBarTiny ? "22px" : "17px"}
                      color="currentColor"
                      filter={activeAccordion === id ? "invert(1)" : "none"}
                      // filter={
                      //   isActive
                      //     ? "invert(1)"
                      //     : isLocationSub
                      //     ? "invert(1)"
                      //     : "none"
                      // }
                      opacity={activeAccordion === id ? 1 : 0.6}
                      _groupHover={{
                        color: activeAccordion === id ? white : textPrimaryMode,
                      }}
                      _groupActive={{ color: white }}
                    />
                  )}
                  {name}
                  <ChevronDownIcon
                    ml="auto"
                    transform={
                      isAccordionOpen ? "rotate(0deg)" : "rotate(-90deg)"
                    }
                    transition="all 0.2s ease-in-out"
                  />
                </Flex>
              </AccordionButton>
            </h2>
            <AccordionPanel p="0.5rem 0 0.5rem 2.5rem">
              <Flex
                direction="column"
                position="relative"
                _before={{
                  content: `""`,
                  position: "absolute",
                  top: "4px",
                  left: "-12px",
                  width: "1px",
                  height: "calc(100% - 8px)",
                  background: "#ddd",
                }}
              >
                {subMenuItems.map((subMenuItem) => {
                  const isSubMenuActive = location.pathname.startsWith(
                    subMenuItem.route
                  ); // ✅ Fix Here

                  // console.log("subMenuItem", subMenuItem);

                  // console.log("isSubMenuActive", isSubMenuActive);

                  return (
                    <Flex
                      as={NavLink}
                      to={subMenuItem.route}
                      key={subMenuItem.name}
                      align="center"
                      height="50px"
                      fontSize="14px"
                      fontWeight="400"
                      // color={
                      //   location.pathname === subMenuItem.route
                      //     ? white
                      //     : textSecondary
                      // }

                      // bg={
                      //   location.pathname === subMenuItem.route
                      //     ? primaryAlt
                      //     : whiteMode
                      // }

                      color={isSubMenuActive ? white : textSecondary}
                      bg={isSubMenuActive ? primaryAlt : whiteMode}
                      borderTopLeftRadius="12px"
                      borderBottomLeftRadius="12px"
                      p="0 18px"
                      transition="background 0.1s ease-in-out"
                      // _hover={{
                      //   background:
                      //     location.pathname === subMenuItem.route
                      //       ? primaryAlt
                      //       : backgroundLightMode,
                      //   fontWeight: "500",
                      //   color:
                      //     location.pathname === subMenuItem.route
                      //       ? white
                      //       : textPrimaryMode,
                      // }}
                      _hover={{
                        fontWeight: "500",
                        background: isSubMenuActive
                          ? primaryAlt
                          : backgroundLightMode,

                        color: isSubMenuActive ? white : textPrimaryMode,
                      }}
                      pointerEvents={subMenuItem.isDisabled ? "none" : "auto"}
                      opacity={subMenuItem.isDisabled ? 0.5 : 1}
                      cursor={
                        subMenuItem.isDisabled ? "not-allowed" : "pointer"
                      }
                      // isActive={(match, location) =>
                      //   location.pathname === subMenuItem.route
                      // }
                    >
                      {subMenuItem.name}
                    </Flex>
                  );
                })}
              </Flex>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      )}
    </>
  );
};

export default TabLinkNew;
